export default function stringifyHTML(html: string) {
  return html
    .replace(/<[^>]*>?/gm, '|')
    .replace(/\|+/g, '|')
    .replace(/^\|/, '')
    .replace(/\|$/, '')
    .replace(/\|/gm, ' | ');
}
